<div class="card row">
    <div id="boxes" style="float: left; width: 100%;">
        <h4 style="color: #001d46;padding-left: 15px;" *ngIf="flightSearchData">{{flightSearchData.tripType}}</h4>
        <div id="leftbox">
            <div *ngFor="let iList of flight.FlightDetails.Details" class="col-md-12">
                <div *ngFor="let list of iList; let i = index" class="cardList">
                    <div class=row>
                    <div class="col-md-3 col-5">
                      <i class="fas fa-plane"></i> <b>{{list.Origin.CityName}} ({{list.Origin.AirportCode}})</b>
                     </div>
                     <div class="col-md-1 col-2 nopad text-center">
                      <i class="fas fa-exchange-alt"></i>
                    </div>
                   <div class="col-md-3 col-5 nopad"> 
                       <b>{{list.Destination.CityName}} ({{list.Destination.AirportCode}})</b>
                       </div>

                       <div class="col-md-3 col-12">
                    <b>{{list.Origin.DateTime | date : 'd MMM y'}}</b>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="f-14">
            <span class="travellerSpace"><i class="fa fa-male"></i> {{ traveller?.adults }} Adult </span>
            <span class="travellerSpace" *ngIf="traveller?.childrens">|<i class="fa fa-child"></i> {{
                traveller?.childrens }} Child| </span>
            <span class="travellerSpace" *ngIf="traveller?.infants">|<i class="fas fa-baby"></i> {{ traveller?.infants
                }} Infants </span>
            <span class="travellerSpace" *ngIf="flightSearchData">| {{flightSearchData.CabinClass}} </span>
            <a class="changeFlight float-right m-2" (click)="backClicked()"> Change Flight</a>
            <a (click)=" isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic"
                class="float-right m-2"> Flight Details
            </a>
        </div>
    </div>
</div>
<div id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true" class="row">

    <tabset>
        <tab heading="ITINERARY">
                <app-flight-details-itinerary [flight]="flight"></app-flight-details-itinerary>
        </tab>
        <tab heading="BAGGAGE">
                <app-flight-details-baggage [flight]="flight"></app-flight-details-baggage>
        </tab>
        <tab heading="FARE BREAKUP & RULES">
                <app-flight-details-fare [flight]="flight"></app-flight-details-fare>
        </tab>
    </tabset>
    
</div>